module.exports = __webpack_public_path__ + "static/media/May2021Newsletter.8e26ed4e.pdf";